import React, { useContext } from "react";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import * as urlService from "../../view/urlService";
import { TableContext } from "../../index";
import { sortObjectsByAlphabet } from "../../utils";

function ScheduleChooseDeviceField({ selectedType, setDeviceId, deviceId, devices = [] }) {
    const menuPortalTarget = typeof document !== 'undefined' ? document.body : null;
    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const onChange = (selectedOption) => {
        const value = selectedOption?.value ?? -1;
        setDeviceId(value);
        setConfig({ ...config, deviceId: value });

        if (Number(value) === -1) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('device')
            });
            return;
        }

        const device = devices.find(item => item.id === Number(value));

        if (device) {
            history.push({
                pathname: history.pathname,
                search: urlService.updateFilters('device', device.hostName)
            });
        }
    };

    let devicesToRender = devices.filter(device => device.deviceType?.id === Number(selectedType));
    devicesToRender = sortObjectsByAlphabet(devicesToRender, 'hostName');

    const options = devicesToRender.map((device) => ({
        value: device.id,
        label: device.hostName
    }));

    return (
        <div className="modal-v2-schedule-field-group">
            <label htmlFor="schedule-device">Device <span className="modal-v2-required-mark">*</span></label>
            <Select
                inputId="schedule-device"
                className="oct_selectsearch-v2"
                classNamePrefix="oct-selectsearchsub-v2"
                value={options.find((option) => option.value === Number(deviceId)) || null}
                onChange={onChange}
                options={options}
                isSearchable
                isDisabled={Number(selectedType) <= 0}
                menuPlacement="auto"
                menuPosition="fixed"
                menuPortalTarget={menuPortalTarget}
                maxMenuHeight={240}
                minMenuHeight={240}
                placeholder="Select device"
                noOptionsMessage={() => Number(selectedType) <= 0 ? "Select a device type first" : "No devices available"}
            />
        </div>
    );
}

export default ScheduleChooseDeviceField;
